import { render, staticRenderFns } from "./apartments-locations-location.vue?vue&type=template&id=1979d7ee&scoped=true&"
import script from "./apartments-locations-location.ts?vue&type=script&lang=ts&"
export * from "./apartments-locations-location.ts?vue&type=script&lang=ts&"
import style0 from "./apartments-locations-location.scss?vue&type=style&index=0&id=1979d7ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1979d7ee",
  null
  
)

export default component.exports